import React from 'react'
import MCAParameterUpdateModalSF from './MCAParameterUpdateModalSF'

const MCAProfitAndLossUI = ({ account, context, pnlList, yearList, onRefreshClick,
  mcaParameterUpdateMode, onMcaParameterUpdateClick, onMcaParameterUpdateCancel, selectedParameterName
}) =>
  <div id='mcaPnL' className='g_m_top_200'>
    <span className='g_large'><b>Profit and Loss</b></span>
    <table className='g_table'>
      <thead className='g_sticky'><tr><td />
        {
          pnlList.map((pnl, i) =>
            <td key={i} className='g_text_right'>
              <b className='g_no_wrap'>{pnl.financialYear}</b>
            </td>
          )
        }
      </tr></thead>
      <tbody>
        <RowUI pnlList={pnlList} name='netSalesOrRevenue' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='otherOperatingIncome' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='revenueFromOperations' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='costOfMaterialConsumed' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='changeInInventories' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='purchases' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='directOrManufacturingExpenses' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='employeeBenefitExpenses' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='sellingGeneralAndAdministrativeExpenses' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='otherExpenses' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='totalExpenses' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='ebitda' />
        <RowUI pnlList={pnlList} name='depreciationAndAmortization' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='profitBeforeInterestAndTax' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='interestAndBankCharges' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='profitAfterInterestAndBeforeTax' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='otherNonOperatingIncome' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='otherNonOperatingExpenses' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='profitBeforeExceptionalOrExtraordinaryItemsAndTax' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='shareOfProfitLossInAssociates' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='exceptionalOrExtraordinaryItems' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='profitBeforeTax' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='currentTax' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} name='deferredTax' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='profitAfterTax' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
        <RowUI pnlList={pnlList} total={true} name='retainedProfit' onMcaParameterUpdateClick={onMcaParameterUpdateClick} />
      </tbody>
    </table>

    <MCAParameterUpdateModalSF
      account={account} context={context}
      updateMode={mcaParameterUpdateMode}
      onCancelClick={onMcaParameterUpdateCancel}
      onRefreshClick={onRefreshClick}
      reportType='profit_and_loss'
      selectedParameterName={selectedParameterName}
      yearList={yearList}
    />
  </div>
{/*
  private String impairmentOnFinancialInstruments;
*/}

const RowUI = ({ pnlList, total, name, onMcaParameterUpdateClick }) =>
  <tr className={total && 'g_table_total'}>
    <td><Desc name={name} /></td>
    {
      pnlList.map((bs, i) =>
        <td key={i} className='g_text_right'>
          {bs[name]}
        </td>
      )
    }
    <td>
      {
        onMcaParameterUpdateClick &&
        <span className='icon icon-pencil' onClick={onMcaParameterUpdateClick} data-name={name} />
      }
    </td>
  </tr>

const Desc = ({ name }) =>
  <span>
    {(() => {
      switch (name) {
        case 'netSalesOrRevenue':
          return 'Net Sales/Revenue'
        case 'otherOperatingIncome':
          return 'Other Operating Income'
        case 'revenueFromOperations':
          return 'Revenue from Operations'
        case 'costOfMaterialConsumed':
          return 'Cost of Material Consumed'
        case 'changeInInventories':
          return 'Change in Inventories'
        case 'purchases':
          return 'Purchases'
        case 'directOrManufacturingExpenses':
          return 'Direct/Manufacturing Expenses'
        case 'employeeBenefitExpenses':
          return 'Employee Benefit Expenses'
        case 'sellingGeneralAndAdministrativeExpenses':
          return 'Selling, General and Administrative Expenses'
        case 'otherExpenses':
          return 'Other Expenses'
        case 'totalExpenses':
          return 'Total Expenses'
        case 'ebitda':
          return 'EBITDA'
        case 'depreciationAndAmortization':
          return 'Depreciation & Amortization'
        case 'profitBeforeInterestAndTax':
          return 'Profit before Interest and Tax'
        case 'interestAndBankCharges':
          return 'Interest & Bank Charges'
        case 'profitAfterInterestAndBeforeTax':
          return 'Profit after Interest and before Tax'
        case 'otherNonOperatingIncome':
          return 'Other Non Operating Income'
        case 'otherNonOperatingExpenses':
          return 'Other Non Operating Expenses'
        case 'profitBeforeExceptionalOrExtraordinaryItemsAndTax':
          return 'Profit before Exceptional/Extraordinary Items and Tax'
        case 'shareOfProfitLossInAssociates':
          return 'Share of Profit/(Loss) in Associates'
        case 'exceptionalOrExtraordinaryItems':
          return 'Exceptional/Extraordinary Items'
        case 'profitBeforeTax':
          return 'Profit before Tax'
        case 'currentTax':
          return 'Current Tax'
        case 'deferredTax':
          return 'Deferred Tax'
        case 'profitAfterTax':
          return 'Profit after Tax'
        case 'retainedProfit':
          return 'Retained Profit'
        default:
          return name
      }
    })()}
  </span>

export default MCAProfitAndLossUI
